import DefaultTrendingMenu, { StandaloneTrendingMenu, StandaloneTrendingMenuProps } from '@/components/TrendingMenu';
import { LabradorComponent, StandaloneComponent } from '@/types/component';
import { useMobileAppState } from 'lib/hooks/useMobileAppState';
import mergeProps from 'lib/utils/mergeProps';

const SvenskdamStandaloneTrendingMenu: StandaloneComponent<StandaloneTrendingMenuProps> = (props) => {
  return (
    <StandaloneTrendingMenu
      {...mergeProps(
        {
          options: {
            className: 'hideInMobileApp',
          },
        },
        props
      )}
    />
  );
};

export const standalone = SvenskdamStandaloneTrendingMenu;

const SvenskdamLabradorTrendingMenu: LabradorComponent = ({ type, data, meta, descendants }) => {
  const { isMobileApp } = useMobileAppState();

  if (isMobileApp) {
    return null;
  }

  return <DefaultTrendingMenu {...{ type, data, meta, descendants }} />;
};

export default SvenskdamLabradorTrendingMenu;
